import callAllFn from '@julofinance/web-helpers/dist/fn/callAllFn';

import { UseMutationOptions, useMutation } from '@hooks/react-query';
import { ApiResult } from '@models/api';
import { CustomError, fetcherMutation } from '@utils/react-query';
import { SubmitFormParam } from '../models';

function useRSubmitApplication(
  options: UseMutationOptions<
    ApiResult<unknown>,
    Record<string, unknown>,
    Omit<SubmitFormParam, 'ktp' | 'ktpSelfie'>
  > = {},
) {
  const { onError, ...resOptions } = options;

  return useMutation<
    ApiResult<unknown>,
    Record<string, unknown>,
    SubmitFormParam
  >({
    mutationFn: async ({ context, variables }) =>
      await fetcherMutation({
        context: { ...context, method: 'POST', path: 'application/v2/submit' },
        variables,
      }),
    onError: callAllFn((err: CustomError) => {
      const statusCode = err.payload?.statusCode;
      if (statusCode === 403) return window.location.replace('/home');
    }, onError),
    ...resOptions,
  });
}

export default useRSubmitApplication;
